import { VIEWS } from "./global";

import Layout from "../views/layout";
import Home from "../views/wrapped-views/home/home";
import AboutUs from "../views/wrapped-views/about-us/about-us";
import ComponentShowcase from "../views/wrapped-views/component-showcase/component-showcase";
import Services from "../views/wrapped-views/services/services";
import Cases from "../views/wrapped-views/cases/cases";
import ContactUsView from "../views/wrapped-views/contact-us/contact-us";
import Blog from "../views/wrapped-views/blog/blog";
import BlogDetails from "../views/wrapped-views/blog-details/blog-details";
import CaseDetails from "../views/wrapped-views/case-details/case-details";
import LegalPage from "../views/wrapped-views/legal-page/legal-page";

export const routes = {
  [VIEWS.LAYOUT]: {
    fullPath: "/",
    staticPath: "/",
    key: VIEWS.LAYOUT,
    label: "",
    element: <Layout />,
  },
  [VIEWS.HOME]: {
    fullPath: "/",
    staticPath: "/",
    key: VIEWS.HOME,
    label: "Home",
    element: <Home />,
  },
  [VIEWS.COMPONENT_SHOWCASE]: {
    fullPath: "/component-showcase",
    staticPath: "/component-showcase",
    key: VIEWS.COMPONENT_SHOWCASE,
    label: "Component Showcase",
    element: <ComponentShowcase />,
  },
  [VIEWS.ABOUT_US]: {
    fullPath: "/about-us",
    staticPath: "/about-us",
    key: VIEWS.ABOUT_US,
    label: "About Us",
    element: <AboutUs />,
  },
  [VIEWS.SERVICES]: {
    fullPath: "/services",
    staticPath: "/services",
    key: VIEWS.SERVICES,
    label: "Services",
    element: <Services />,
  },
  [VIEWS.OUR_WORK]: {
    fullPath: "/our-work",
    staticPath: "/our-work",
    key: VIEWS.OUR_WORK,
    label: "Our Work",
    element: <Cases />,
  },
  [VIEWS.CONTACT]: {
    fullPath: "/contact",
    staticPath: "/contact",
    key: VIEWS.CONTACT,
    label: "Contact",
    element: <ContactUsView />,
  },
  [VIEWS.BLOG]: {
    fullPath: "/blog",
    staticPath: "/blog",
    key: VIEWS.BLOG,
    label: "Blog",
    element: <Blog />,
  },
  [VIEWS.CAREER]: {
    fullPath: "/career",
    staticPath: "/career",
    key: VIEWS.CAREER,
    label: "Career",
    element: <></>,
  },
  [VIEWS.BLOG_DETAILS]: {
    fullPath: "/blog-details/:id",
    staticPath: "/blog-details",
    key: VIEWS.BLOG_DETAILS,
    label: "Blog Details",
    element: <BlogDetails />,
  },
  [VIEWS.CASE_DETAILS]: {
    fullPath: "/case-details/:id",
    staticPath: "/case-details",
    key: VIEWS.CASE_DETAILS,
    label: "Case Details",
    element: <CaseDetails />,
  },
  [VIEWS.LEGAL_PAGE]: {
    fullPath: "/legal-page",
    staticPath: "/legal-page",
    key: VIEWS.LEGAL_PAGE,
    label: "Legal Page",
    element: <LegalPage />,
  },
};
